import React, { useEffect, useState } from "react";
import LeftArrow from "../assets/arrow-left-white.png";
import RightArrow from "../assets/arrow-right-white.png";
import Button from "./Bouton";

export default function NewsCarrousel() {
    const [news, setNews] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        fetch('https://alpine-larochelle.com/api/news')
        .then((response) => response.json())
        .then((data) => setNews(data))
        .catch((error) => console.error('Error fetching news:', error));
    }, []);

    const nextNews = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % news.length);
        setTimeout(() => setIsTransitioning(false), 500);
    };
    
    const prevNews = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) =>
          prevIndex === 0 ? news.length - 1 : prevIndex - 1
        );
        setTimeout(() => setIsTransitioning(false), 500);
    };
    
    if (news.length === 0) {
        return (
            <section className="news-carrousel">
                <div className="news-carrousel__loading">
                    <div className="loading-spinner"></div>
                    <p>Chargement des actualités...</p>
                </div>
            </section>
        );
    }
    
    const currentNews = news[currentIndex];

    return (
        <section className="news-carrousel">
            <div className="news-carrousel__header">
                <div className="news-carrousel__title-wrapper">
                    <span className="news-carrousel__subtitle">Actualités</span>
                    <h2>Les dernières nouvelles de votre Alpine Store La Rochelle</h2>
                </div>
                <div className="news-carrousel__indicators">
                    {news.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => {
                                if (isTransitioning) return;
                                setIsTransitioning(true);
                                setCurrentIndex(index);
                                setTimeout(() => setIsTransitioning(false), 500);
                            }}
                        />
                    ))}
                </div>
            </div>
            
            <div className="news-carrousel__container">
                <button 
                    className="news-carrousel__nav news-carrousel__nav--prev"
                    onClick={prevNews}
                    disabled={isTransitioning}
                >
                    <img src={LeftArrow} alt="Article précédent" />
                </button>
                
                <div className="news-carrousel__card">
                    <div className="news-carrousel__image-container">
                        <img 
                            src={`https://alpine-larochelle.com/uploads/${currentNews.image}`} 
                            alt={currentNews.title}
                            className="news-carrousel__image"
                        />
                        <div className="news-carrousel__image-overlay"></div>
                    </div>
                    
                    <div className="news-carrousel__content">
                        <div className="news-carrousel__content-header">
                            <h3 className="news-carrousel__title">{currentNews.title}</h3>
                            <div className="news-carrousel__text">
                                <div dangerouslySetInnerHTML={{ __html: currentNews.text }} />
                            </div>
                        </div>
                        
                        <div className="news-carrousel__content-footer">
                            <Button 
                                Text="Découvrir l'article"
                                Link={`/news/${currentNews._id}`}
                            />
                        </div>
                    </div>
                </div>
                
                <button 
                    className="news-carrousel__nav news-carrousel__nav--next"
                    onClick={nextNews}
                    disabled={isTransitioning}
                >
                    <img src={RightArrow} alt="Article suivant" />
                </button>
            </div>
        </section>
    );
}